import {
  Tooltip,
  TooltipContent,
  TooltipTrigger,
} from '@/components/ui/tooltip';

interface AnnualHeatmapCellProps {
  rating: number;
  date: string;
  moonPercent: number;
  gcHours: string;
}

function getRatingColor(rating: number): string {
  if (rating >= 8) return 'bg-emerald-600';
  if (rating >= 6) return 'bg-green-500';
  if (rating >= 4) return 'bg-lime-400';
  if (rating >= 2) return 'bg-amber-300';
  return 'bg-muted/30';
}

export const AnnualHeatmapCell: React.FC<AnnualHeatmapCellProps> = ({
  rating,
  date,
  moonPercent,
  gcHours,
}) => {
  return (
    <Tooltip>
      <TooltipTrigger asChild>
        <div
          className={`w-full aspect-square rounded-[2px] ${getRatingColor(rating)} border border-black/10 cursor-default`}
        />
      </TooltipTrigger>
      <TooltipContent side="top" className="text-xs">
        <p className="font-medium">{date}</p>
        <p>Rating: {rating}/10</p>
        <p>Moon: {moonPercent}%</p>
        <p>GC visible: {gcHours}</p>
      </TooltipContent>
    </Tooltip>
  );
};
